import React, { useContext, useMemo } from "react";

const CategoriesContext = React.createContext({});

const CategoriesProvider = ({ value, ...props }) => {
  const categories = useMemo(() => {
    return value.reduce((accumulator, currentValue) => ({
      ...accumulator,
      [currentValue.replace("TASKCATEGORY_", "")]: currentValue,
    }), {});
  }, [value]);

  return (
    <CategoriesContext.Provider
      {...props}
      value={categories}
    />
  );
};

export const useCategories = () => {
  const context = useContext(CategoriesContext);

  if (context === undefined) {
    throw new Error("useCategories must be used within a CategoriesProvider");
  }

  return context;
};

export default CategoriesProvider;
